import type { IServiceGraderPool } from '../../interfaces/serviceGraderPoolInterfaces';
import { NoResult } from '../shared/NoResult';
import { ServiceGraderPoolListRow } from './ServiceGraderPoolListRow';

export function ServiceGraderPoolListBody(props: IListTableBodyProps) {
    if (props.serviceGraderPools.length) {
        return (
            <>
                {props.serviceGraderPools.map((serviceGraderPool) => (
                    <ServiceGraderPoolListRow
                        key={serviceGraderPool.id}
                        onDelete={props.onDelete}
                        serviceGraderPool={serviceGraderPool}
                        serviceId={props.serviceId}
                    />
                ))}
            </>
        );
    } else {
        return <NoResult colspan={2} />;
    }
}

interface IListTableBodyProps {
    onDelete: (id: string) => void;
    serviceGraderPools: IServiceGraderPool[];
    serviceId: string;
}
